import { ThemeName } from "@/types/styles/ThemeName";
import { createContext } from "react";

export const ChosenThemeContext = createContext<ThemeName | undefined>(undefined);

export default ChosenThemeContext;